import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDuplicate = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M0 0h10v4H4v6H0z" />
    <path fill="#616061" d="M16 6H6v10h10z" />
  </svg>
);
export default SvgDuplicate;
